/**
 * Предыстория новичка (ISSUE-136): одна фраза поверх первого боя на {@link STORY_MS}, касания проходят сквозь неё, бой
 * не стоит. Когда показывать — решает `storyDue` в `app/ftue.ts`.
 */
import { finishStory, ftueStore, STORY_MS, storyDue } from "../../app/ftue";
import { useStore } from "../../app/hooks";
import { appStore } from "../../app/store";
import { useEffect } from "preact/hooks";
import { Plate } from "../kit";
import "./story.css";
import type { HudT } from "./messages";

export function StoryPlate({ t, wave }: { t: HudT; wave: number }) {
  const created = useStore(appStore, (s) => s.auth.created);
  const bestWave = useStore(appStore, (s) => s.player?.bestWave ?? 0);
  const done = useStore(ftueStore, (f) => f.storyDone);
  const shown = storyDue({ created, wave, bestWave, done });
  useEffect(() => {
    if (!shown) return;
    const timer = setTimeout(() => finishStory(), STORY_MS);
    return () => clearTimeout(timer);
  }, [shown]);
  if (!shown) return null;
  return (
    <div class="kit story" data-testid="story" aria-live="polite">
      <Plate class="story__plate">{t("hud.story")}</Plate>
    </div>
  );
}
